
  function onChangeFabricItemQuantity(target, id) {
    const input = document.getElementById(id);
    const drawer = document.getElementById('cart-drawer-container');
    const inputEvent = new CustomEvent('input', {bubbles: true});
    const changeEvent = new CustomEvent('change', {bubbles: true});

    input.value=Number(target.value*100);
    input.dispatchEvent(inputEvent);
    input.dispatchEvent(changeEvent);
  }
  
